import { render, staticRenderFns } from "./CreateAgreementRoute.vue?vue&type=template&id=678a965b&"
import script from "./CreateAgreementRoute.vue?vue&type=script&lang=js&"
export * from "./CreateAgreementRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports